module.exports = __webpack_public_path__ + "img/coins-icons-bsc.b8616be1.png";